import { render, staticRenderFns } from "./NewsStandard.vue?vue&type=template&id=c5e9c8ba&scoped=true&"
import script from "./NewsStandard.vue?vue&type=script&lang=js&"
export * from "./NewsStandard.vue?vue&type=script&lang=js&"
import style0 from "./NewsStandard.vue?vue&type=style&index=0&id=c5e9c8ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e9c8ba",
  null
  
)

export default component.exports